module.exports = __webpack_public_path__ + "img/ivymarket.770e3eb9.png";